import { NetworkError } from '@/features/graphql/types'
import { ApolloError } from '@apollo/client'
import { ErrorResponse } from '@apollo/client/link/error'

export const getGraphqlUriFromLicenceUrl = (uri: string): string => `https://${uri}/graphql/`

export const isNetworkError = (errorResponse: ErrorResponse): boolean => {
    return (
        !errorResponse.graphQLErrors?.length &&
        !errorResponse.protocolErrors?.length &&
        !!errorResponse.networkError &&
        !Object.keys(errorResponse.networkError).length
    )
}

export const isNetworkConnectionError = (error: unknown) => {
    if (!(error instanceof ApolloError)) return false

    return (
        !error.graphQLErrors.length &&
        !error.clientErrors.length &&
        (error.networkError as NetworkError).missingNetworkConnection
    )
}
